/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PutApiV1ClassroomdisciplineClassModulesIdMutationRequest,
  PutApiV1ClassroomdisciplineClassModulesIdMutationResponse,
  PutApiV1ClassroomdisciplineClassModulesIdPathParams,
  PutApiV1ClassroomdisciplineClassModulesId400,
  PutApiV1ClassroomdisciplineClassModulesId401,
  PutApiV1ClassroomdisciplineClassModulesId404,
  PutApiV1ClassroomdisciplineClassModulesId500,
} from "../../types/classPlanningClassModuleController/PutApiV1ClassroomdisciplineClassModulesId.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { putApiV1ClassroomdisciplineClassModulesId } from "../../clients/classPlanningClassModuleController/putApiV1ClassroomdisciplineClassModulesId.ts";

export const putApiV1ClassroomdisciplineClassModulesIdMutationKey = () =>
  [{ url: "/api/v1/classroomdiscipline/class-modules/:id" }] as const;

export type PutApiV1ClassroomdisciplineClassModulesIdMutationKey = ReturnType<
  typeof putApiV1ClassroomdisciplineClassModulesIdMutationKey
>;

export function putApiV1ClassroomdisciplineClassModulesIdMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PutApiV1ClassroomdisciplineClassModulesIdMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey = putApiV1ClassroomdisciplineClassModulesIdMutationKey();
  return mutationOptions<
    PutApiV1ClassroomdisciplineClassModulesIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1ClassroomdisciplineClassModulesId400
      | PutApiV1ClassroomdisciplineClassModulesId401
      | PutApiV1ClassroomdisciplineClassModulesId404
      | PutApiV1ClassroomdisciplineClassModulesId500
    >,
    {
      id: PutApiV1ClassroomdisciplineClassModulesIdPathParams["id"];
      data?: PutApiV1ClassroomdisciplineClassModulesIdMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return putApiV1ClassroomdisciplineClassModulesId(id, data, config);
    },
  });
}

/**
 * @description Edição não-destrutiva: atualiza o cabeçalho, os campos das aulas de disciplinas existentes (sala, professor, tipo e flags) e permite ADICIONAR novas Turmas e Disciplinas. Bloqueia (400) remover Turma/Disciplina, alterar quantidade/recorrência de disciplina existente, ou editar Módulo com aulas já realizadas. **(Requer Authorization para autenticação)**
 * @summary Editar Módulo (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/class-modules/:id}
 */
export function usePutApiV1ClassroomdisciplineClassModulesId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiV1ClassroomdisciplineClassModulesIdMutationResponse,
      ResponseErrorConfig<
        | PutApiV1ClassroomdisciplineClassModulesId400
        | PutApiV1ClassroomdisciplineClassModulesId401
        | PutApiV1ClassroomdisciplineClassModulesId404
        | PutApiV1ClassroomdisciplineClassModulesId500
      >,
      {
        id: PutApiV1ClassroomdisciplineClassModulesIdPathParams["id"];
        data?: PutApiV1ClassroomdisciplineClassModulesIdMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PutApiV1ClassroomdisciplineClassModulesIdMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    putApiV1ClassroomdisciplineClassModulesIdMutationKey();

  const baseOptions = putApiV1ClassroomdisciplineClassModulesIdMutationOptions(
    config,
  ) as UseMutationOptions<
    PutApiV1ClassroomdisciplineClassModulesIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1ClassroomdisciplineClassModulesId400
      | PutApiV1ClassroomdisciplineClassModulesId401
      | PutApiV1ClassroomdisciplineClassModulesId404
      | PutApiV1ClassroomdisciplineClassModulesId500
    >,
    {
      id: PutApiV1ClassroomdisciplineClassModulesIdPathParams["id"];
      data?: PutApiV1ClassroomdisciplineClassModulesIdMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PutApiV1ClassroomdisciplineClassModulesIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1ClassroomdisciplineClassModulesId400
      | PutApiV1ClassroomdisciplineClassModulesId401
      | PutApiV1ClassroomdisciplineClassModulesId404
      | PutApiV1ClassroomdisciplineClassModulesId500
    >,
    {
      id: PutApiV1ClassroomdisciplineClassModulesIdPathParams["id"];
      data?: PutApiV1ClassroomdisciplineClassModulesIdMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiV1ClassroomdisciplineClassModulesIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1ClassroomdisciplineClassModulesId400
      | PutApiV1ClassroomdisciplineClassModulesId401
      | PutApiV1ClassroomdisciplineClassModulesId404
      | PutApiV1ClassroomdisciplineClassModulesId500
    >,
    {
      id: PutApiV1ClassroomdisciplineClassModulesIdPathParams["id"];
      data?: PutApiV1ClassroomdisciplineClassModulesIdMutationRequest;
    },
    TContext
  >;
}
